import {
  getVisitList
} from '@/api/visitList'

export default {
  namespaced: true,
  state: {
    listData: {
      list: [],
      total: 0
    },
    query: {
      pageNo: 1,
      pageSize: 20,
      shopId: '',
      visitStatus: '',
      startTime: '',
      endTime: ''
    },
    isRefreshList: true // 列表进行重新请求
  },
  mutations: {
    /** @desc 更新列表数据 */
    updateListData (state, data) {
      state.listData = {
        list: state.query.pageNo === 1 ? data.list : [...state.listData.list, ...data.list],
        total: data.total
      }
    },
    /** @desc 更新搜索参数 */
    updateQuery (state, query) {
      state.query = query
    },
    /** @desc init参数 */
    initQuery (state) {
      state.query = {
        pageNo: 1,
        pageSize: 20,
        shopId: '',
        visitStatus: '',
        startTime: '',
        endTime: ''
      }
    }
  },
  actions: {
    /** @desc 获取列表数据 */
    async getListData ({ commit, state }, params = {}) {
      try {
        for (const key in params) {
          if (params[key] === '') {
            delete params[key]
          }
        }
        const res = await getVisitList(params)
        commit('updateListData', res)
        console.log(res)
      } catch (e) {
        console.log(e)
      }
    }
  }
}
